function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// background click is just a convience method, not an actual a11y issue

import React, { Component } from 'react';
import { Button, CardFlip, Select } from '@deephaven/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsGear } from '@deephaven/icons';
import memoizee from 'memoizee';
import debounce from 'lodash.debounce';
import Log from '@deephaven/log';
import "./InputFilter.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('InputFilter');
var UPDATE_DEBOUNCE = 150;
class InputFilter extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "inputRef", void 0);
    _defineProperty(this, "getItemLabel", memoizee((columns, index) => {
      var _columns$index = columns[index],
        name = _columns$index.name,
        type = _columns$index.type;
      if (index > 0 && columns[index - 1].name === name || index < columns.length - 1 && columns[index + 1].name === name) {
        var shortType = type.substring(type.lastIndexOf('.') + 1);
        return "".concat(name, " (").concat(shortType, ")");
      }
      return name;
    }, {
      max: 1000
    }));
    _defineProperty(this, "sendUpdate", debounce(() => {
      var onChange = this.props.onChange;
      var _this$state = this.state,
        column = _this$state.column,
        value = _this$state.value,
        isValueShown = _this$state.isValueShown;
      onChange({
        column,
        isValueShown,
        value
      });
    }, UPDATE_DEBOUNCE));
    this.handleColumnChange = this.handleColumnChange.bind(this);
    this.handleInputKeyPress = this.handleInputKeyPress.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleSettingsCancel = this.handleSettingsCancel.bind(this);
    this.handleSettingsClick = this.handleSettingsClick.bind(this);
    this.handleSettingsSave = this.handleSettingsSave.bind(this);
    this.handleBackgroundClick = this.handleBackgroundClick.bind(this);
    this.inputRef = /*#__PURE__*/React.createRef();
    var _column = props.column,
      _isValueShown = props.isValueShown,
      _value = props.value;
    this.state = {
      column: _column,
      selectedColumn: _column,
      value: _value,
      isValueShown: _isValueShown
    };
  }
  componentDidUpdate(prevProps, prevState) {
    var propColumn = this.props.column;
    var _this$state2 = this.state,
      column = _this$state2.column,
      value = _this$state2.value,
      isValueShown = _this$state2.isValueShown;
    if (propColumn !== prevProps.column) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        column: propColumn,
        selectedColumn: propColumn
      });
    }
    if (isValueShown !== undefined && isValueShown && isValueShown !== prevState.isValueShown) {
      this.focusInput();
    }
    if (column !== prevState.column || value !== prevState.value || isValueShown !== prevState.isValueShown) {
      this.sendUpdate();
    }
  }
  componentWillUnmount() {
    this.sendUpdate.flush();
  }
  handleColumnChange(eventTargetValue) {
    var columns = this.props.columns;
    var selectedColumn = columns[parseInt(eventTargetValue, 10)];
    log.debug2('handleColumnChange', selectedColumn);
    this.setState({
      selectedColumn,
      value: undefined
    });
  }
  handleInputKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.setState(_ref => {
        var value = _ref.value;
        return value == null ? {
          value: ''
        } : null;
      }, () => {
        this.sendUpdate();
        this.sendUpdate.flush();
      });
    }
  }
  handleValueChange(event) {
    var value = event.target.value;
    log.debug2('handleValueChange', value);
    this.setState({
      value
    });
  }
  handleSettingsCancel() {
    var column = this.state.column;
    this.setState({
      selectedColumn: column,
      isValueShown: true
    });
  }
  handleSettingsSave() {
    var selectedColumn = this.state.selectedColumn;
    this.setState({
      column: selectedColumn,
      isValueShown: true
    });
  }
  handleSettingsClick(event) {
    var column = this.state.column;
    this.setState({
      selectedColumn: column,
      isValueShown: false
    });
    event.stopPropagation();
  }
  handleBackgroundClick(event) {
    // allow clicking anywhere in the background to select and focus the input
    if (event.target !== this.inputRef.current) {
      this.focusInput();
    }
  }
  focusInput() {
    if (this.inputRef.current !== null) {
      this.inputRef.current.select();
      this.inputRef.current.focus();
    }
  }
  clearFilter() {
    this.setState({
      value: ''
    });
  }
  setFilterState(_ref2) {
    var name = _ref2.name,
      type = _ref2.type,
      value = _ref2.value,
      isValueShown = _ref2.isValueShown;
    var column = name != null && type != null ? {
      name,
      type
    } : undefined;
    var update = isValueShown === undefined ? {
      column,
      value
    } : {
      column,
      value,
      isValueShown
    };
    this.setState(update);
  }
  render() {
    var columns = this.props.columns;
    var _this$state3 = this.state,
      column = _this$state3.column,
      isValueShown = _this$state3.isValueShown,
      selectedColumn = _this$state3.selectedColumn,
      value = _this$state3.value;
    var inputLength = value == null || value.length === 0 ? InputFilter.PLACEHOLDER.length : value.length;
    var titleLabel = null;
    if (column != null) {
      var columnIndex = columns.findIndex(item => item.name === column.name && item.type === column.type);
      titleLabel = columnIndex >= 0 ? this.getItemLabel(columns, columnIndex) : column.name;
    }
    return /*#__PURE__*/_jsxs(CardFlip, {
      className: "input-filter fill-parent-absolute",
      isFlipped: isValueShown !== null && isValueShown !== void 0 ? isValueShown : false,
      children: [/*#__PURE__*/_jsx("div", {
        className: "input-filter-settings-card",
        children: /*#__PURE__*/_jsxs("div", {
          className: "input-filter-settings-content",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "input-filter-settings-grid",
            children: [/*#__PURE__*/_jsx("label", {
              children: "Filter Column"
            }), /*#__PURE__*/_jsxs(Select, {
              value: String(columns.findIndex(item => item.name === (selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.name) && item.type === (selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.type))),
              className: "custom-select",
              onChange: this.handleColumnChange,
              children: [columns.map((columnItem, index) => /*#__PURE__*/_jsx("option", {
                value: index,
                children: this.getItemLabel(columns, index)
              }, "".concat(columnItem.name, "/").concat(columnItem.type))), columns.length === 0 && /*#__PURE__*/_jsx("option", {
                value: "-1",
                disabled: true,
                children: "No Available Columns"
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "text-muted small",
              children: "Input filter control will apply its filter to all columns matching this name in this dashboard."
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "input-filter-settings-buttons",
            children: [/*#__PURE__*/_jsx(Button, {
              kind: "secondary",
              onClick: this.handleSettingsCancel,
              disabled: column == null,
              children: "Cancel"
            }), /*#__PURE__*/_jsx(Button, {
              kind: "primary",
              className: "ml-2",
              onClick: this.handleSettingsSave,
              disabled: selectedColumn == null,
              children: "Save"
            })]
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "input-filter-value-card",
        onClick: this.handleBackgroundClick,
        children: [/*#__PURE__*/_jsx("div", {
          className: "input-filter-column",
          children: /*#__PURE__*/_jsxs("div", {
            className: "input-filter-column-title",
            children: [titleLabel, " Filter"]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "d-flex justify-content-center align-items-center h-100 w-100",
          children: /*#__PURE__*/_jsx("div", {
            className: "input-filter-value-input d-flex flex-column justify-content-center",
            children: /*#__PURE__*/_jsx("input", {
              type: "text",
              ref: this.inputRef,
              placeholder: InputFilter.PLACEHOLDER,
              value: value !== null && value !== void 0 ? value : '',
              onChange: this.handleValueChange,
              onKeyPress: this.handleInputKeyPress,
              style: {
                width: "".concat(inputLength + 3, "ch")
              },
              spellCheck: "false"
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "input-filter-menu",
          children: /*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            className: "m-2 px-2",
            onClick: this.handleSettingsClick,
            icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: vsGear,
              transform: "grow-4"
            }),
            tooltip: "Input Filter Settings"
          })
        })]
      })]
    });
  }
}
_defineProperty(InputFilter, "PLACEHOLDER", 'Enter value...');
_defineProperty(InputFilter, "defaultProps", {
  column: null,
  isValueShown: false,
  value: null
});
export default InputFilter;
//# sourceMappingURL=InputFilter.js.map